import { lastPathSegment } from "./storedDirectory";

const RESULTS_DIRECTORY_MARKERS = [
  "/Transient_response_simulation_parallel_dictionary/",
  "/Transient_response_simulation_parallel/",
];

export const RESULT_LOG_FOLDER = "__job_log__";

export type ResultFolderLabel = {
  iteration?: number;
  title: string;
};

export type TransientInputFile = {
  name: string;
  path?: string;
  relativePath: string;
  url: string;
};

export type TransientResultFile = {
  name: string;
  path?: string;
  url: string;
};

export type TransientResultFolder = {
  files: TransientResultFile[];
  folderName: string;
};

export type TransientResultIteration = {
  files: TransientResultFile[];
  folderName: string;
  iteration: number;
};

export type TransientResultScenario = {
  iterations: TransientResultIteration[];
  name: string;
};

export const formatResultFileName = (name: string) => lastPathSegment(name);

export const resultFileKey = (folderName: string, fileName: string) => `${folderName}/${fileName}`;

export const parseResultFolderName = (folderName: string): ResultFolderLabel => {
  const match = folderName.trim().match(/^(.*?)\s+iteration\s+(\d+)$/i);
  const rawTitle = match?.[1] ? match[1].trim() : folderName.trim();
  const title = rawTitle.replace(/^timestamps\s+/i, "").trim() || rawTitle;
  if (!match || match[2] == null) return { title };
  return { iteration: Number(match[2]), title };
};

export const folderNameForFile = (file: { name: string; path?: string }): null | string => {
  if (file.name.includes("/")) {
    const [folder, ...rest] = file.name.split("/").filter(Boolean);
    if (folder && rest.length > 0) return folder;
  }
  if (!file.path) return null;
  const marker = RESULTS_DIRECTORY_MARKERS.find((item) => file.path?.includes(item));
  if (!marker) return null;
  const index = file.path.indexOf(marker);
  if (index < 0) return null;
  const rest = file.path.slice(index + marker.length);
  const [folder, ...fileParts] = rest.split("/").filter(Boolean);
  if (!folder || fileParts.length === 0) return null;
  return folder;
};
